module.exports = __webpack_public_path__ + "static/media/smart-tv-icon.15bf575b.svg";